import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as sentEmailApi from '../../api/sentEmailApi';

export const sendNewsletter = createAsyncThunk(
  'sentEmail/send',
  async (payload, { rejectWithValue }) => {
    try {
      return await sentEmailApi.sendNewsletter(payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de l\'envoi.');
    }
  }
);

export const fetchSentEmails = createAsyncThunk(
  'sentEmail/fetch',
  async (_, { rejectWithValue }) => {
    try {
      return await sentEmailApi.fetchSentEmails();
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors du chargement.');
    }
  }
);

const sentEmailSlice = createSlice({
  name: 'sentEmail',
  initialState: {
    list: [],
    loading: false,
    error: null,
    sendSuccess: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSendSuccess: (state) => {
      state.sendSuccess = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNewsletter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendNewsletter.fulfilled, (state, action) => {
        state.loading = false;
        state.sendSuccess = action.payload;
        state.list = [action.payload, ...state.list];
      })
      .addCase(sendNewsletter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSentEmails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSentEmails.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchSentEmails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSendSuccess } = sentEmailSlice.actions;
export default sentEmailSlice.reducer;
